import { z } from 'zod';

import { BorrowerId, WorkoutPlanId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateRepaymentPlanOfferNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: WorkoutPlanId,
  borrowerIds: z.array(BorrowerId),
});

export const GenerateRepaymentPlanOfferNoticeSideEffect = GenerateRepaymentPlanOfferNoticeSideEffectContext.extend({
  type: z.literal('generateRepaymentPlanOfferNotice'),
});
export type GenerateRepaymentPlanOfferNoticeSideEffect = z.infer<typeof GenerateRepaymentPlanOfferNoticeSideEffect>;
